var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { head } from '../../../utils/helper/lodash_replacements';
export class AspectCssAnimationNamed {
    parent;
    animationName;
    constructor(parent, animationName) {
        makeObservable(this);
        this.parent = parent;
        this.animationName = animationName;
    }
    get aspectAnimation() {
        return this.parent;
    }
    get aspect() {
        return this.aspectAnimation.aspect;
    }
    get app() {
        return this.aspect.context.app;
    }
    get isNamedAnimationRunning() {
        const { animationstart } = this.aspect.aspectEvents.latestEventOfType;
        return this.aspectAnimation.isCssAnimationRunning && !!animationstart && animationstart.animationName === this.animationName;
    }
    get isNamedAnimationComplete() {
        const animationstarts = this.animationstarts; // observe
        const animationends = this.animationends; // observe
        if (animationends.length === 0)
            return false;
        if (animationstarts.length === 0)
            return true;
        return head(this.animationends).runtimeTime >= head(this.animationstarts).runtimeTime;
    }
    get animationstarts() {
        return this.aspectAnimation.animationstarts.filter(event => event.animationName === this.animationName);
    }
    get animationends() {
        return this.aspectAnimation.animationends.filter(event => event.animationName === this.animationName);
    }
}
__decorate([
    computed
], AspectCssAnimationNamed.prototype, "isNamedAnimationRunning", null);
__decorate([
    computed
], AspectCssAnimationNamed.prototype, "isNamedAnimationComplete", null);
